import React from "react";

const IconLeadsTracking = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 107 107"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M53.1406 51.5293C63.0818 51.5293 71.1406 43.4704 71.1406 33.5293C71.1406 23.5882 63.0818 15.5293 53.1406 15.5293C43.1995 15.5293 35.1406 23.5882 35.1406 33.5293C35.1406 43.4704 43.1995 51.5293 53.1406 51.5293Z" />
      <path d="M20.1914 78.7093C28.9714 86.0793 40.2814 90.5293 52.6414 90.5293C65.0014 90.5293 76.9714 85.8193 85.8414 78.0593C80.8214 64.8893 68.0714 55.5293 53.1414 55.5293C38.2114 55.5293 25.0414 65.1993 20.1914 78.7093Z" />
      <path
        d="M3.23 32.9698C1.45 32.9698 0 31.5298 0 29.7398V14.2998C0 6.41977 6.41 0.00976562 14.29 0.00976562H29.73C31.51 0.00976562 32.96 1.44977 32.96 3.23977C32.96 5.02977 31.52 6.46977 29.73 6.46977H14.29C9.97 6.46977 6.45 9.98977 6.45 14.3098V29.7498C6.45 31.5298 5.01 32.9798 3.22 32.9798L3.23 32.9698Z"
        className="fill-secondary-on-hover-target"
      />
      <path
        d="M102.81 32.97C101.03 32.97 99.5803 31.53 99.5803 29.74V14.3C99.5803 9.98 96.0603 6.46 91.7403 6.46H76.3003C74.5203 6.46 73.0703 5.02 73.0703 3.23C73.0703 1.44 74.5103 0 76.3003 0H91.7403C99.6203 0 106.03 6.41 106.03 14.29V29.73C106.03 31.51 104.59 32.96 102.8 32.96L102.81 32.97Z"
        className="fill-secondary-on-hover-target"
      />
      <path
        d="M91.7403 106.05H76.3003C74.5203 106.05 73.0703 104.6 73.0703 102.82C73.0703 101.04 74.5103 99.5901 76.3003 99.5901H91.7403C96.0603 99.5901 99.5803 96.0701 99.5803 91.7501V76.3101C99.5803 74.5301 101.02 73.0801 102.81 73.0801C104.6 73.0801 106.04 74.5201 106.04 76.3101V91.7501C106.04 99.6301 99.6303 106.04 91.7503 106.04L91.7403 106.05Z"
        className="fill-secondary-on-hover-target"
      />
      <path
        d="M29.7417 106.05H14.3017C6.42172 106.05 0.0117188 99.6398 0.0117188 91.7598V76.3198C0.0117188 74.5398 1.45172 73.0898 3.24172 73.0898C5.03172 73.0898 6.47172 74.5298 6.47172 76.3198V91.7598C6.47172 96.0798 9.99172 99.5998 14.3117 99.5998H29.7517C31.5317 99.5998 32.9817 101.05 32.9817 102.83C32.9817 104.61 31.5417 106.06 29.7517 106.06L29.7417 106.05Z"
        className="fill-secondary-on-hover-target"
      />
    </svg>
  );
};

export default IconLeadsTracking;
